// ============================================================
// liveryStyle - the `--livery` custom property a liveried element sets
// (v8.361.0). One helper so the rail row, the gallery card and header
// and the editor's swatches paint from the same value, whether the team
// wears a palette name or a picked hex. Undefined for no livery, so the
// element's own fallback (`var(--livery, …)`) shows.
// ============================================================
import type { CSSProperties } from 'react';
import { liveryColour, type Livery } from '../engine/roster/team';

export function liveryStyle(livery: Livery | null | undefined): CSSProperties | undefined {
  if (!livery) return undefined;
  return { '--livery': liveryColour(livery) } as CSSProperties;
}
